import { call, put, select, takeLatest } from "redux-saga/effects";
import { getCountriesAction } from "../../constants";
import { selectToken } from "../selectors";
import { getCountries } from "../../axios";
import {
  getCountriesSuccess,
  getCountriesFailure,
} from "../actions/get-countries-actions";

function* getCountriesSaga() {
  try {
    const token: string = yield select(selectToken);
    const res = yield call(getCountries, token);
    yield put(
      getCountriesSuccess(
        res.data.countries.map((c) => ({
          ...c,
          ISO_code: c.ISO_code.toLowerCase(),
        }))
      )
    );
  } catch (e) {
    yield put(getCountriesFailure(e));
  }
}

export function* watchGetCountriesSaga() {
  yield takeLatest(getCountriesAction.requested, getCountriesSaga);
}
